import styled from "@emotion/styled";
import { BASE_COLORS } from "../../../../emotion-theme";

export const SearchSuggestList = styled.ul`
  max-height: 350px;
  overflow-y: auto;
  position: absolute;
  width: 100%;

  scroll: none;
  box-shadow: 0px 1px 12px 1px ${BASE_COLORS.slightLightGray};
  border: solid 1px ${BASE_COLORS.slightLightGray};
  border-radius: 0px 2px 2px 0px;

  z-index: 100;
  list-style-type: none;
  margin: 0;
  padding: 0;
  background-color: ${BASE_COLORS.white};
`;
